import { isValidatedPrescriptionPackage, PrescriptionPackage } from '~libs.shared.prescription';

export const canContinueAfterPrescriptionsSent = (prescriptionPackages: PrescriptionPackage[]): boolean =>
   prescriptionPackages.every((prescriptionPackage) => isValidatedPrescriptionPackage(prescriptionPackage));
